import { openDB, type IDBPDatabase } from 'idb'
import type { SavedDocument } from '../types/document'

// Opt-in local storage. Only the structured result the user chose to save is
// kept, on this device only. Images and the full OCR text are never stored.

const DB_NAME = 'samjho-local'
const STORE = 'saved'
/** v1 auto-saved every analysis; v2 removes that store and saves only on request. */
const LEGACY_STORE = 'documents'

const memoryStore = new Map<string, SavedDocument>()

async function getDb(): Promise<IDBPDatabase | null> {
  if (typeof indexedDB === 'undefined') return null
  try {
    return await openDB(DB_NAME, 2, {
      upgrade(db) {
        if (db.objectStoreNames.contains(LEGACY_STORE)) db.deleteObjectStore(LEGACY_STORE)
        if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { keyPath: 'id' })
      }
    })
  } catch {
    return null
  }
}

export async function saveDocument(item: SavedDocument): Promise<void> {
  const db = await getDb()
  if (db) await db.put(STORE, item)
  else memoryStore.set(item.id, item)
}

export async function listSaved(): Promise<SavedDocument[]> {
  const db = await getDb()
  const items = db ? ((await db.getAll(STORE)) as SavedDocument[]) : [...memoryStore.values()]
  return items.sort((a, b) => b.savedAt.localeCompare(a.savedAt))
}

export async function deleteSaved(id: string): Promise<void> {
  const db = await getDb()
  if (db) await db.delete(STORE, id)
  else memoryStore.delete(id)
}

export async function clearSaved(): Promise<void> {
  const db = await getDb()
  if (db) await db.clear(STORE)
  else memoryStore.clear()
}
